// Captures ?src=<code> (e.g. from the business card QR code) on landing and
// remembers it so it can be attached to the lead even if the visitor browses
// to other pages before submitting the form or chatting.
const STORAGE_KEY = 'lead_src';

export function captureLeadSource(): void {
  try {
    const src = new URLSearchParams(window.location.search).get('src');
    if (src && /^[a-z0-9_-]{1,32}$/i.test(src)) {
      localStorage.setItem(STORAGE_KEY, src.toLowerCase());
    }
  } catch {
    // storage unavailable — attribution is best-effort
  }
}

export function getLeadSource(): string | undefined {
  try {
    return localStorage.getItem(STORAGE_KEY) || undefined;
  } catch {
    return undefined;
  }
}
